import { __ as Basic__, n__ as BasicN__, ns__ as BasicNs__, s__ as BasicS__, } from './lib';
export { interpolate } from './interpolation';
const isBrowser = typeof window !== 'undefined';
export const __ = (str) => { var _a; return (isBrowser && ((_a = window.__) === null || _a === void 0 ? void 0 : _a.call(window, str))) || Basic__(str); };
export const s__ = (str) => { var _a; return (isBrowser && ((_a = window.s__) === null || _a === void 0 ? void 0 : _a.call(window, str))) || BasicS__(str); };
export const n__ = (singular, plural, num) => {
    var _a;
    return (isBrowser && ((_a = window.n__) === null || _a === void 0 ? void 0 : _a.call(window, singular, plural, num))) ||
        BasicN__(singular, plural, num);
};
export const ns__ = (singular, plural, num) => {
    var _a;
    return (isBrowser && ((_a = window.ns__) === null || _a === void 0 ? void 0 : _a.call(window, singular, plural, num))) ||
        BasicNs__(singular, plural, num);
};
//# sourceMappingURL=index.js.map